import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ScrollableFeed from "react-scrollable-feed";
import { Container } from "~/src/components/global";

const useStyles = makeStyles((theme) => ({
  fullScreen: {
    display: "flex",
    flexDirection: "column",
    background: theme.palette.background.default,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  header: {
    position: "relative",
    zIndex: 1,
  },
  body: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: 0,
    flexGrow: 1,
    width: "100%",
  },
  scrollable: {
    width: "100%",
    height: 0,
    flexGrow: 1,
  },
  scrollableInner: {
    height: "100%",
  },
  footer: {
    position: "relative",
    zIndex: 1,
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(2),
    width: "100%",
    maxWidth: theme.breakpoints.values.sm,
    [theme.breakpoints.up("sm")]: {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

export default function ChatLayout(props) {
  const { children, header, footer } = props;
  const classes = useStyles();

  return (
    <div className={classes.fullScreen}>
      <header className={classes.header}>{header}</header>

      <main className={classes.body}>
        <div className={classes.scrollable}>
          <div className={classes.scrollableInner}>
            <ScrollableFeed>
              <Container size="sm">
                {children}
              </Container>
            </ScrollableFeed>
          </div>
        </div>

        <footer className={classes.footer}>{footer}</footer>
      </main>
    </div>
  );
}
